import React from 'react';
import { StyleSheet, View } from 'react-native';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
import { Button, rem, Spacer } from 'design-system';
const WithdrawConfirmationModal = {
    show: (accountNumber, sortCode, onPress) => {
        Modal.show(<>
        <Spacer h={16}/>
        <Text TextThin-14 centered Secondary>
          {`Your money will be transferred to your\nbank account ${sortCode.replace(/(\d\d)(\d\d)(\d\d)/, '$1-$2-$3')} ${accountNumber}`}
        </Text>
        <Spacer h={32}/>
        <View style={styles.btnContainer}>
          <Button brandReversed title="Cancel" onPress={Modal.hide}/>
          <Spacer h={8}/>
          <Button brand title="Yes, I’m sure" onPress={onPress}/>
        </View>
      </>, {
            title: 'Are you sure you want to\nwithdraw?',
            containerStyle: styles.modal,
        });
    },
    hide: (onHideCallback) => {
        Modal.hide(onHideCallback);
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    btnContainer: {
        paddingHorizontal: rem(16),
    },
});
export default WithdrawConfirmationModal;
